import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import POSLayout from "./layouts/POSLayout";
import AdminLayout from "./layouts/AdminLayout";
import Login from "./pages/AdminDashboard/Login";
import FaceLogin from "./pages/AdminDashboard/FaceLogin";
import RootLayout from "./layouts/RootLayout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Invoice3WithVat from "./components/Invoices/Invoice3WithVat";
import AddFeedbackForm from "./pages/AdminDashboard/CustomerFeedback/AddFeedbackForm";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/POS/*" element={<POSLayout />} />
          <Route path="/admin/" element={<Login />} />
          <Route path="/admin/face-login/" element={<FaceLogin />} />
          <Route path="/admin/*" element={<AdminLayout />} />
          <Route path="/*" element={<RootLayout />} />
          <Route path="/invoice" element={<Invoice3WithVat />} />
          <Route
            path="/feedback"
            element={<AddFeedbackForm />}
          />
        </Routes>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </BrowserRouter>
    </>
  );
}

export default App;